export const services = [
    {
        id: 1,
        title: 'Far Camı Montajı',
        description: '568. Sk. No:6 Altın Örnek Sanayi Sitesi İvedik Osb. ANK...',
        image: 'https://images.unsplash.com/photo-1601129181405-734c0d510074',
        link: '/hizmet/far-cami-montaji'
    },
    {
        id: 2,
        title: 'Far ve Stop Tamiri',
        description: '568. Sk. No:6 Altın Örnek Sanayi Sitesi İvedik Osb. ANK...',
        image: 'https://images.unsplash.com/photo-1542282088-fe8426682b8f',
        link: '/hizmet/far-ve-stop-tamiri'
    },
    {
        id: 3,
        title: 'Far Camı Değişimi',
        description: '568. Sk. No:6 Altın Örnek Sanayi Sitesi İvedik Osb. ANK...',
        image: 'https://images.unsplash.com/photo-1577903514522-a78357092dac',
        link: '/hizmet/far-cami-degisimi'
    },
    {
        id: 4,
        title: 'Detaylı Far Temizliği',
        description: '568. Sk. No:6 Altın Örnek Sanayi Sitesi İvedik Osb. ANK...',
        image: 'https://images.unsplash.com/photo-1598586958772-8bf368215c2a',
        link: '/hizmet/detayli-far-temizligi'
    },
    {
        id: 5,
        title: 'Kırık Far Tamiri',
        description: '568. Sk. No:6 Altın Örnek Sanayi Sitesi İvedik Osb. ANK...',
        image: 'https://images.pexels.com/photos/17915248/pexels-photo-17915248.jpeg',
        link: '/hizmet/kirik-far-tamiri'
    },
    {
        id: 6,
        title: 'Far Mercek Değişimi',
        description: '568. Sk. No:6 Altın Örnek Sanayi Sitesi İvedik Osb. ANK...',
        image: 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800&q=80',
        link: '/hizmet/far-mercek-degisimi'
    },
    {
        id: 7,
        title: 'Gösterge Camı Tamir ve Değişimi',
        description: '568. Sk. No:6 Altın Örnek Sanayi Sitesi İvedik Osb. ANK...',
        image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&q=80',
        link: '/hizmet/gosterge-cami-tamir'
    }
];

export const testimonials = [
    {
        id: 1,
        name: 'Mehmet Yıldız',
        comment: 'BMW aracımın farlarını değiştirdim ve sonuç gerçekten harika oldu. Farlar artık çok daha parlak ve gece sürüşleri çok daha güvenli. Teşekkürler!',
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150'
    },
    {
        id: 2,
        name: 'Ayşe Kılıç',
        comment: 'Far değişimi için Ankara Merkez Far\'a gittim ve gerçekten profesyonel bir hizmet aldım. Farlarımın eski halinden eser yok, çok memnunum',
        avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150'
    },
    {
        id: 3,
        name: 'Ali Çelik',
        comment: 'Stop lambam kırılmıştı ve hemen tamir ettirdim. İşlemi çok hızlı ve kaliteli bir şekilde yaptılar. Artık stop lambam ilk günkü gibi çalışıyor',
        avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150'
    },
    {
        id: 4,
        name: 'Derya Öztürk',
        comment: 'Stop tamiri için geldim ve gerçekten memnun kaldım. Hem hızlı hem de uygun fiyatlı bir hizmetti. Teşekkürler!',
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150'
    },
    {
        id: 5,
        name: 'Burak Demir',
        comment: 'Far merceğimde sorun vardı ve tamir ettirmek için başvurdum. Mercek tamiri sonrasında farlarımın ışık dağılımı çok daha iyi oldu.',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150'
    },
    {
        id: 6,
        name: 'Selin Aksoy',
        comment: 'Far temizliği yaptırdım ve farlarımın parlaklığı gerçekten arttı. Aracım çok daha yeni görünüyor. Çok memnunum!',
        avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150'
    }
];

export const contactInfo = {
    phone: '05523067171',
    phone2: '05050100671',
    email: 'merkezfar@gmail.com',
    address: '568. Sk. No:6 Altın Örnek Sanayi Sitesi İvedik Osb.',
    city: 'Ankara',
    facebook: 'https://www.facebook.com/people/Merkez-FAR-ve-STOP-Tamirat%C4%B1/100064083691747/',
    instagram: 'https://www.instagram.com/merkez_far?utm_medium=copy_link'
};

export const serviceDetails = {
    'far-cami-montaji': {
        title: 'Far Camı Montajı',
        description: 'Profesyonel far camı montajı hizmeti ile aracınızın farlarını yeni gibi yapıyoruz.',
        features: [
            'Orijinal yedek parça kullanımı',
            'Uzman kadro ile montaj',
            'Garanti belgeli hizmet',
            'Hızlı teslimat'
        ],
        image: 'https://images.unsplash.com/photo-1601129181405-734c0d510074'
    },
    'far-ve-stop-tamiri': {
        title: 'Far ve Stop Tamiri',
        description: 'Kırık, çatlak veya kararmış far ve stoplarınızı tamir ediyoruz.',
        features: [
            'Detaylı hasar analizi',
            'Profesyonel tamir işlemi',
            'Kalite garantisi',
            'Uygun fiyat'
        ],
        image: 'https://images.unsplash.com/photo-1542282088-fe8426682b8f'
    },
    'far-cami-degisimi': {
        title: 'Far Camı Değişimi',
        description: 'Far camınız çatlamış veya kırılmış mı? Hemen değiştirin!',
        features: [
            'Tüm araç modellerine uygun',
            'Hızlı değişim',
            'Orijinal parça seçeneği',
            'İşçilik garantisi'
        ],
        image: 'https://images.unsplash.com/photo-1577903514522-a78357092dac'
    },
    'detayli-far-temizligi': {
        title: 'Detaylı Far Temizliği',
        description: 'Kararmış ve solan farlarınıza yeni bir hayat veriyoruz.',
        features: [
            'Özel temizlik solüsyonları',
            'Parlatma işlemi',
            'UV koruma',
            'Uzun ömürlü sonuç'
        ],
        image: 'https://images.unsplash.com/photo-1598586958772-8bf368215c2a'
    },
    'kirik-far-tamiri': {
        title: 'Kırık Far Tamiri',
        description: 'Kırık farlarınızı ekonomik çözümlerle tamir ediyoruz.',
        features: [
            'Profesyonel yapıştırma',
            'Dayanıklı tamir',
            'Estetik görünüm',
            'Bütçe dostu'
        ],
        image: 'https://images.pexels.com/photos/17915248/pexels-photo-17915248.jpeg'
    },
    'far-mercek-degisimi': {
        title: 'Far Mercek Değişimi',
        description: 'Far merceğiniz buğulanıyor mu? Işık kalitesi düşük mü? Profesyonel far mercek değişimi hizmetimizle aracınızın farlarını ilk günkü performansına kavuşturuyoruz. Tüm araç modellerine uygun orijinal ve yan sanayi mercek seçenekleri mevcuttur.',
        features: [
            'Orijinal ve yan sanayi mercek seçenekleri',
            'Işık kaybı önleme',
            'Profesyonel montaj ve kalibrasyon',
            'Test ve ayar hizmeti',
            'Su sızıntısı önleme',
            'Buğulanma garantisi'
        ],
        image: 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=1200&q=80',
        seoTitle: 'Far Mercek Değişimi Ankara | Profesyonel Mercek Tamiri',
        seoDescription: 'Ankara merkez far olarak far mercek değişimi hizmeti. Buğulanan, yanan veya hasar görmüş far merceklerinin değişimi. İvedik OSBde hizmetinizdeyiz.'
    },
    'gosterge-cami-tamir': {
        title: 'Gösterge Camı Tamir ve Değişimi',
        description: 'Gösterge panelinizin camı çatladı mı? Kararmış mı? Profesyonel gösterge camı tamir ve değişimi hizmetimizle aracınızın gösterge panelini yeni gibi yapıyoruz.',
        features: [
            'Tüm gösterge tipleri ve modeller',
            'Orijinal yedek parça',
            'Hızlı servis',
            'Kaliteli malzeme kullanımı',
            'Uygun fiyat garantisi',
            'Digital ve analog gösterge paneli'
        ],
        image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1200&q=80',
        seoTitle: 'Gösterge Camı Tamir ve Değişimi Ankara | Profesyonel Hizmet',
        seoDescription: 'Ankarada gösterge camı tamir ve değişimi hizmeti. Çatlak, kararmış veya kırık gösterge camlarının profesyonel tamiri. Tüm araç modellerine uygun çözümler.'
    }
};
